import React, { useState } from 'react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: ''
  });
  const [submitting, setSubmitting] = useState(false);
  const [submitted, setSubmitted] = useState(false);

  const handleInputChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

const handleSubmit = async (e) => {
  e.preventDefault();
  setSubmitting(true);

  try {
    const response = await fetch("https://formspree.io/f/xnjddvwo", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify(formData),
    });

    if (response.ok) {
      setSubmitted(true);
      setFormData({
        name: "",
        email: "",
        subject: "",
        message: "",
      });
    } else {
      alert("Something went wrong. Please try again.");
    }
  } catch (error) {
    alert("Network error. Please try again later.");
  } finally {
    setSubmitting(false);
  }
};

  const contactInfo = [
    {
      icon: '📧',
      title: 'Email Us',
      value: 'info@intlrr.com',
      description: 'Send us an email and we\'ll respond within 24 hours'
    },
    {
      icon: '📞',
      title: 'Call Us',
      value: '+91-9897474108',
      description: 'Speak with our enrolment team Monday to Friday, 9 AM - 6 PM'
    },
    {
      icon: '🏢',
      title: 'Visit Us',
      value: 'Mumbai, India',
      description: 'Schedule an in-person meeting at our Mumbai office'
    }
  ];

  const faqs = [
    {
      question: 'Who can enroll in Intlrr programs?',
      answer: 'Our programs are designed for students, recent graduates, and early-career professionals looking to break into or advance in finance. No prior finance experience is required.'
    },
    {
      question: 'What is the format of the classes?',
      answer: 'All our programs are conducted online with live weekend sessions. This allows working professionals and students to participate without disrupting their schedules.'
    },
    {
      question: 'Do you provide placement assistance?',
      answer: 'We focus on preparing you for placements through in-depth interview readiness, resume building, mock interviews, mock group discussions, and end-to-end career preparation. While we do not directly place candidates or offer placement guarantees, our goal is to help you become industry-ready and confident to secure opportunities on your own.'
    },
    {
      question: 'What is the validity of the program registration?',
      answer: 'Your registration remains valid for the duration of the program, with continued access to all course recordings and materials for up to six months after program completion.'
    }
  ];

  return (
    <div className="contact-page" data-testid="contact-page">
      {/* Hero Section */}
      <section className="hero" style={{ minHeight: '60vh' }}>
        <div className="container">
          <div className="hero-content animate-fade-in-up text-center">
            <h1 className="heading-primary mb-lg">Get in Touch</h1>
            <p className="text-large mb-xl" style={{ color: 'var(--text-secondary)', maxWidth: '700px', margin: '0 auto 2rem' }}>
              Have questions about our programs? Ready to start your finance career journey? We're here to help you succeed.
            </p>
          </div>
        </div>
      </section>

      {/* Contact Info */}
      <section className="section" style={{ background: 'var(--surface)' }}>
        <div className="container">
          <div className="grid grid-3 gap-lg">
            {contactInfo.map((info, index) => (
              <div key={index} className="card text-center" data-testid={`contact-info-${index}`}>
                <div style={{ width: '80px', height: '80px', background: 'var(--secondary)', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 1rem' }}>
                  <span style={{ fontSize: '2rem' }}>{info.icon}</span>
                </div>
                <h3 className="heading-tertiary mb-sm" style={{ fontSize: '1.125rem' }}>{info.title}</h3>
                <div className="text-base font-semibold mb-sm" style={{ color: 'var(--secondary)' }}>{info.value}</div>
                <p className="text-sm" style={{ color: 'var(--text-secondary)' }}>{info.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Contact Form */}
      <section className="section">
        <div className="container">
          <div className="grid grid-2 gap-xl">
            {/* Contact Form */}
            <div>
              <h2 className="heading-secondary mb-lg">Send us a Message</h2>
              
              {submitted ? (
                <div className="success-message" data-testid="success-message">
                  <div style={{ background: 'var(--secondary)', color: 'white', padding: '2rem', borderRadius: '1rem', textAlign: 'center' }}>
                    <div style={{ fontSize: '3rem', marginBottom: '1rem' }}>✅</div>
                    <h3 className="heading-tertiary mb-sm" style={{ color: 'white' }}>Thank You!</h3>
                    <p>Your message has been sent successfully. We'll get back to you within 24 hours.</p>
                  </div>
                </div>
              ) : (
                <form onSubmit={handleSubmit} className="contact-form">
                  <div className="grid grid-2 gap-md">
                    <div className="form-group">
                      <label className="form-label">Full Name *</label>
                      <input
                        type="text"
                        name="name"
                        value={formData.name}
                        onChange={handleInputChange}
                        className="form-input"
                        required
                        data-testid="contact-name-input"
                      />
                    </div>
                    
                    <div className="form-group">
                      <label className="form-label">Email Address *</label>
                      <input
                        type="email"
                        name="email"
                        value={formData.email}
                        onChange={handleInputChange}
                        className="form-input"
                        required
                        data-testid="contact-email-input"
                      />
                    </div>
                  </div>
                  
                  <div className="form-group">
                    <label className="form-label">Subject *</label>
                    <select
                      name="subject"
                      value={formData.subject}
                      onChange={handleInputChange}
                      className="form-input"
                      required
                      data-testid="contact-subject-select"
                    >
                      <option value="">Select a subject</option>
                      <option value="General Inquiry">General Inquiry</option>
                      <option value="Program Information">Program Information</option>
                      <option value="Admission Query">Admission Query</option>
                      <option value="Technical Support">Technical Support</option>
                      <option value="Partnership">Partnership Opportunity</option>
                    </select>
                  </div>
                  
                  <div className="form-group">
                    <label className="form-label">Message *</label>
                    <textarea
                      name="message"
                      value={formData.message}
                      onChange={handleInputChange}
                      className="form-textarea"
                      rows="5"
                      required
                      data-testid="contact-message-textarea"
                    />
                  </div>
                  
                  <button 
                    type="submit" 
                    className="btn btn-primary btn-large"
                    disabled={submitting}
                    style={{ width: '100%' }}
                    data-testid="send-message-btn"
                  >
                    {submitting ? 'Sending Message...' : 'Send Message'}
                  </button>
                </form>
              )}
            </div>

            {/* FAQ Section */}
            <div>
              <h2 className="heading-secondary mb-lg">Frequently Asked Questions</h2>
              
              <div className="faq-list">
                {faqs.map((faq, index) => (
                  <div key={index} className="faq-item" data-testid={`faq-${index}`}>
                    <h3 className="heading-tertiary mb-sm" style={{ fontSize: '1rem', color: 'var(--secondary)' }}>
                      {faq.question}
                    </h3>
                    <p className="text-sm mb-lg" style={{ color: 'var(--text-secondary)' }}>
                      {faq.answer}
                    </p>
                  </div>
                ))}
              </div>
              
              <div className="card" style={{ marginTop: '2rem' }}>
                <h3 className="heading-tertiary mb-md" style={{ fontSize: '1.125rem' }}>Still have questions?</h3>
                <p className="text-sm mb-md" style={{ color: 'var(--text-secondary)' }}>
                  Can't find what you're looking for? Our team is here to help you with any specific questions about our programs.
                </p>
                <a href="mailto:info@intlrr.com" className="btn btn-secondary" data-testid="email-directly-btn">
                  Email Us Directly
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Office Hours & Additional Info */}
      <section className="section" style={{ background: 'var(--surface)' }}>
        <div className="container">
          <div className="grid grid-2 gap-xl">
            <div className="card">
              <h3 className="heading-tertiary mb-lg">Office Hours</h3>
              <div className="space-y-md">
                <div className="flex justify-between">
                  <span>Monday - Friday</span>
                  <span style={{ fontWeight: '600' }}>9:00 AM - 6:00 PM</span>
                </div>
                <div className="flex justify-between">
                  <span>Saturday</span>
                  <span style={{ fontWeight: '600' }}>10:00 AM - 4:00 PM</span>
                </div>
                <div className="flex justify-between">
                  <span>Sunday</span>
                  <span style={{ fontWeight: '600' }}>Closed</span>
                </div>
              </div>
              <p className="text-sm mt-lg" style={{ color: 'var(--text-secondary)' }}>
                For urgent inquiries outside office hours, please email us and we'll respond as soon as possible.
              </p>
            </div>
            
            <div className="card">
              <h3 className="heading-tertiary mb-lg">Quick Actions</h3>
              <div className="grid gap-md">
                <a href="/programs" className="btn btn-outline" data-testid="view-programs-contact-btn">
                  View All Programs
                </a>
                <a href="/programs/equity-research" className="btn btn-outline" data-testid="enroll-equity-btn">
                  Enroll in Equity Research
                </a>
                <a href="/resources" className="btn btn-outline" data-testid="download-resources-btn">
                  Download Free Resources
                </a>
                <a href="tel:+91-9897474108" className="btn btn-primary" data-testid="call-now-btn">
                  Call Now: +91-9897474108
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      <style jsx>{`
        .success-message {
          animation: fadeInUp 0.6s ease-out;
        }

        .faq-item {
          border-bottom: 1px solid var(--border);
          padding-bottom: 1.5rem;
          margin-bottom: 1.5rem;
        }

        .faq-item:last-child {
          border-bottom: none;
          margin-bottom: 0;
        }

        .space-y-md > * + * {
          margin-top: 1rem;
        }

        @keyframes fadeInUp {
          from {
            opacity: 0;
            transform: translateY(20px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
      `}</style>
    </div>
  );
};

export default Contact;